"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UIMediaObject;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _renderProp = require("../utils/propTypes/renderProp");

var _UIMedia = _interopRequireDefault(require("./UIMedia"));

var _UIMediaBody = _interopRequireDefault(require("./UIMediaBody"));

var _UIMediaLeft = _interopRequireDefault(require("./UIMediaLeft"));

var _UIMediaRight = _interopRequireDefault(require("./UIMediaRight"));

function UIMediaObject(props) {
  var children = props.children,
      itemLeft = props.itemLeft,
      itemRight = props.itemRight,
      MediaBody = props.MediaBody,
      MediaLeft = props.MediaLeft,
      MediaRight = props.MediaRight,
      rest = (0, _objectWithoutProperties2.default)(props, ["children", "itemLeft", "itemRight", "MediaBody", "MediaLeft", "MediaRight"]);
  return _react.default.createElement(_UIMedia.default, rest, itemLeft ? _react.default.createElement(MediaLeft, null, itemLeft) : null, _react.default.createElement(MediaBody, null, children), itemRight ? _react.default.createElement(MediaRight, null, itemRight) : null);
}

UIMediaObject.propTypes = (0, _extends2.default)({}, _UIMedia.default.propTypes, {
  itemLeft: _propTypes.default.node,
  itemRight: _propTypes.default.node,
  MediaBody: (0, _renderProp.getPropType)(_UIMediaBody.default),
  MediaLeft: (0, _renderProp.getPropType)(_UIMediaLeft.default),
  MediaRight: (0, _renderProp.getPropType)(_UIMediaRight.default)
});
UIMediaObject.defaultProps = (0, _extends2.default)({}, _UIMedia.default.defaultProps, {
  MediaBody: _UIMediaBody.default,
  MediaLeft: _UIMediaLeft.default,
  MediaRight: _UIMediaRight.default
});
UIMediaObject.displayName = 'UIMediaObject';
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3729/js/layout/UIMediaObject.js
// module id = 104
// module chunks = 209 210 211 212